import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';

import { Globals } from '../_Globals/globals'; 

import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';

@Injectable() 
export class CommonService {
    public token: string;
 

    constructor(private http: Http, private globals: Globals) {
        // set token if saved in local storage
        var currentUser = JSON.parse(localStorage.getItem('currentUser'));
        this.token = currentUser && currentUser.token;
    }

    getOfs(): Observable<any> {
         
        return this.http.get(this.globals.api_url + 'finance_services/index')
            .map(data => {
                data.json();
                // the console.log(...) line prevents your code from working 
                // either remove it or add the line below (return ...)
                //console.log("I CAN SEE DATA HERE: ", data.json());
                return data.json();
        });
    }

    getGroups(): Observable<any> {
         
        return this.http.get(this.globals.api_url + 'groups/all')
            .map(data => {
                data.json();
                // the console.log(...) line prevents your code from working 
                // either remove it or add the line below (return ...)
                //console.log("I CAN SEE DATA HERE: ", data.json());
                return data.json();
        });
    }

    getStates(): Observable<any> {
         
        return this.http.get(this.globals.api_url + 'states/index')
            .map(data => {
                data.json();
                // the console.log(...) line prevents your code from working 
                // either remove it or add the line below (return ...)
                //console.log("I CAN SEE DATA HERE: ", data.json());
                return data.json();
        });
    }  

    private _buildParams(params: any) {
        let urlSearchParams = new URLSearchParams();

        for(let key in params){
            if(params.hasOwnProperty(key)){
                urlSearchParams.append(key, params[key]);
            }
        }
        return urlSearchParams.toString();
    }

    private _rand(length, current) {
      current = current ? current : '';
      return length ? this._rand(--length, "0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz".charAt(Math.floor(Math.random() * 60)) + current) : current;
    }
}


// WEBPACK FOOTER //
// ./src/app/_Services/common.service.ts